import { endOfYear, format, parse, startOfMonth, startOfYear } from 'date-fns';
import { Input } from '../Form';
import DatePicker from 'react-datepicker';
import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './react-datepicker.css';

type MonthOfYearRangePickerProps = {
  startDate?: string | null;
  endDate?: string | null;
  onChange?: (startDate: string | null, endDate: string | null) => void;
  autoFocus?: boolean;
  variant?: 'inputSquare' | 'input' | 'inputRoundedRight' | 'inputRoundedLeft';
};

export const MonthOfYearRangePicker: React.FC<MonthOfYearRangePickerProps> = ({
  endDate,
  startDate,
  onChange,
  autoFocus,
  variant,
}) => {
  const [startOfThisMonth] = useState(startOfMonth(new Date()));
  const [startOfThisYear] = useState(startOfYear(new Date()));
  const [endOfThisYear] = useState(endOfYear(new Date()));

  return (
    <DatePicker
      selectsRange
      startDate={startDate ? parse(startDate, 'MM', startOfThisMonth) : null}
      endDate={endDate ? parse(endDate, 'MM', startOfThisMonth) : null}
      onChange={([startDate, endDate]) => {
        onChange?.(
          startDate ? format(startDate, 'MM') : null,
          endDate ? format(endDate, 'MM') : null
        );
      }}
      customInput={
        <Input
          variant={variant}
          sx={{ cursor: 'default' }}
          width={125}
          autoComplete="off"
        />
      }
      isClearable
      dateFormat="MMM"
      showYearPicker={false}
      showMonthYearPicker
      minDate={startOfThisYear}
      maxDate={endOfThisYear}
      // minDate={startDate ? parseISO(startDate) : undefined}
      autoFocus={autoFocus}
    />
  );
};
